import React from 'react';
import { Box } from '@mui/material';
import MaterialLink from '@mui/material/Link';
import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import useDesktopMainMenuItemsService from './useDesktopMainMenuItemsService';
import { NavigationItemType } from 'framework/navigation';
import NavigationItemLabel from 'framework/ui/menu/NavigationItemLabel';

const StyledDesktopHeaderMenuItems = styled(Box)(({ theme }: { theme: any }) => ({
  display: 'flex',
  padding: '0 10px',
  alignItems: 'stretch',
  '& .header-menu__container': {
    margin: 0,
    display: 'flex',
    alignItems: 'stretch',
    minWidth: '1px',
  },

  '& .header-menu__item': {
    display: 'inline-flex',
    flexShrink: 0,
    position: 'relative',
    marginBottom: '20px',
    '&:hover .header-menu__item-link.active': {
      '& ~ .header-menu__subitems': {
        display: 'block',
      },
    },
    '& .header-menu__subitems': {
      display: 'none',
      position: 'absolute',
      background: theme.vars.palette.background.paper,
      top: 'calc(100% - 22px)',
      left: 0,
      boxShadow: theme.shadows[3],
      borderRadius: 6,
      minWidth: 180,
      zIndex: 1,
      '& .MuiListItem-root': {
        color: theme.vars.palette.text.primary,
        padding: '9px 16px',
        margin: 0,
        whiteSpace: 'nowrap',
        '&:hover': {
          backgroundColor: theme.vars.palette.action.hover,
        },
      },
    },
  },
  '& .header-menu__item-link': {
    padding: '0px 15px',
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.vars.palette.text.primary,
    textDecoration: 'none',
    flexDirection: 'column',
    justifyContent: 'space-between',
    border: '2px solid transparent',
    '&.active': {
      fontWeight: 600,
      color: theme.vars.palette.primary.main,
      borderBottomColor: theme.vars.palette.primary.main,
    },
    '&::after': {
      content: 'attr(data-text)',
      height: 0,
      visibility: 'hidden',
      overflow: 'hidden',
      userSelect: 'none',
      pointerEvents: 'none',
      fontWeight: 600,
      '@media speech': {
        display: 'none',
      },
    },
  },
}));

const MainNavigationTabs = () => {
  const { visibleTabs, containerRef } = useDesktopMainMenuItemsService();

  return (
    <StyledDesktopHeaderMenuItems>
      <div className="header-menu__container" ref={containerRef}>
        {visibleTabs?.map(({ name, url, exact = false, isAlpha, isBeta }: NavigationItemType) => (
          <div className="header-menu__item" key={`${url}-${name}`} id={url}>
            <NavLink to={url} end={exact}>
              {({ isActive }) => (
                <MaterialLink
                  component="span"
                  data-text={name || url}
                  data-testid={`desktop-menu-item-${name || url}`}
                  className={`header-menu__item-link ${isActive ? 'active' : ''}`}
                >
                  <NavigationItemLabel name={name || url} url={url} isAlpha={isAlpha} isBeta={isBeta} />
                </MaterialLink>
              )}
            </NavLink>
          </div>
        ))}
      </div>
    </StyledDesktopHeaderMenuItems>
  );
};

export default MainNavigationTabs;
